import maps from './maps';
import pointsOfInterest from './pointsOfInterest';
import reports from './reports';
import trackingUnits from './trackingUnits';

export default [
  {
    header: 'sidebar.general',
    iconName: 'List',
    children: [...maps, ...reports, ...trackingUnits, ...pointsOfInterest] //Only to check permission in children inside
  },
  ...maps,
  ...reports,
  ...trackingUnits,
  ...pointsOfInterest
];
